// extracted by mini-css-extract-plugin
module.exports = {"jds-content__separator":"content_jds-content__separator__bOxyb","jds-content__wrapper":"content_jds-content__wrapper__9e0A_"};